<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Parametre</h3>
          </div>
          <div>
            <div
              class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push"
              m-dropdown-toggle="hover"
              aria-expanded="true"
            >
              <a
                href="#"
                class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill m-dropdown__toggle"
              >
                <i class="la la-plus m--hide"></i>
                <i class="la la-ellipsis-h"></i>
              </a>
              <div class="m-dropdown__wrapper" style="z-index: 101;">
                <span
                  class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
                  style="left: auto; right: 21.5px;"
                ></span>
                <div class="m-dropdown__inner">
                  <div class="m-dropdown__body">
                    <div class="m-dropdown__content">
                      <ul class="m-nav">
                        <li class="m-nav__section m-nav__section--first m--hide">
                          <span class="m-nav__section-text">Quick Actions</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    <a
                      :href="'#/parameters'"
                      class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                    >
                      <i class="la la-angle-left"></i>
                    </a>
                    Parametre Ekle
                  </h3>
                </div>
              </div>
            </div>
                         
            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Parametre Adı</label>
                    <input type="text"  :class="{ 'is-invalid': $v.parameter.name.$error }" v-model="parameter.name" class="form-control m-input" placeholder="Parametre Adı giriniz." />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Açıklama</label>
                    <textarea  :class="{ 'is-invalid': $v.parameter.description.$error }" class="form-control m-input" v-model="parameter.description" placeholder="Parametre açıklamasını giriniz." id="exampleTextarea" rows="3"></textarea>
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Parametre değeri</label>
                    <input type="text"  :class="{ 'is-invalid': $v.parameter.value.$error }" v-model="parameter.value" class="form-control m-input" placeholder="Parametre Değerini giriniz." />
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Parametre Data Tipi</label>
                    <select :class="{ 'is-invalid': $v.parameter.dataType.$error }" 
                            v-model="parameter.dataType" class="form-control m-input" 
                            placeholder="Parametre Data Tipini giriniz.">
																			    <option
                                v-for="option in dataTypes" 
                                v-bind:value="option.id"
                                v-bind:key="option.description"
                                >{{ option.description }}</option
                              >
                                      </select>
                  </div>
                </div>  

                  <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Parametre Kullanım Tipi</label>
                    <select :class="{ 'is-invalid': $v.parameter.usageType.$error }" 
                            v-model="parameter.usageType" class="form-control m-input" 
                            placeholder="Parametre Kullanım Tipini giriniz.">
																			    <option
                                v-for="option in usageTypes" 
                                v-bind:value="option.id"
                                v-bind:key="option.description"
                                >{{ option.description }}</option
                              >
                                      </select>
                  </div>
                </div>  
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button type="button" @click="parameter.id==0?create():update()" class="spbtn">Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>  
            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required,  decimal } from "vuelidate/lib/validators";
import {_create,_getById,_update, _getDataTypes, _getUsageTypes} from '../../services/ParameterService'

export default {
created() {
  this.getDataTypes();
  this.getUsageTypes();
  if(Number(this.$route.params.id)!=0)
        {
          this.parameter.id=Number(this.$route.params.id);
              this.getById();
        }
},

  data() {
    return {
      parameter:{
        id:0,
        name:'',
        description:'',
        value:null,
        usageType:null,
        usageTypeName:'',
        dataType :null,
        dataTypeName:'',

      },
    dataTypes:[],
    usageTypes:[]
    }

  },
    validations: {
    parameter: {
      name: { required },
           description: { required },
           value: { required },
           usageType: { required,decimal },
           dataType: { required ,decimal},
    }
  },
methods: {
  create:function(){
          this.$v.parameter.$touch();
      if (this.$v.parameter.$error) return;
          // let loader=this.$loading.show();
    _create(this.parameter).then(response=>{
      // loader.hide();
      if(response.data.success)
        this.$router.push({ name: 'parameters' })
    });
  },
  update:function(){
          this.$v.parameter.$touch();
      if (this.$v.parameter.$error) return;
    _update(this.parameter).then(response=>{
      if(response.data.success)
        this.$router.push({ name: 'parameters' })
    });
  },
  getById:function(){
    _getById(Number(this.$route.params.id)).then(response=>{
      if(response.data.success)
      this.parameter=response.data.data;
      else
      this.$router.push({ name: 'parameters' })
    })
  },
  getDataTypes:function(){
    _getDataTypes().then(response=>{
      if(response.data.success)
      this.dataTypes=response.data.data;
      else
      this.$router.push({ name: 'parameters' })
    })
  },
  getUsageTypes:function(){
    _getUsageTypes().then(response=>{
      if(response.data.success)
      this.usageTypes=response.data.data;
      else
      this.$router.push({ name: 'parameters' })
    })
  }
},
};
</script>